import type { AnalyticsProperties } from '@play-co/gcinstant';
import { gcinstant } from '../Controllers/AppController';
import { env } from '../config';
import type {
  FirstEntryUserProperties,
  LastEntryUserProperties,
} from './properties';
import { State } from '../../replicant/schema';
import { getPowerUpBonusPerHour } from '../../replicant/features/powerups/getters';
import {
  getBalance,
  getEnergy,
  getLeague,
} from '../../replicant/features/game/game.getters';

export function sendEntryFinalAnalytics(
  state: State,
  entryDataPayload: Record<string, any>,
  now: number,
): Promise<void> {
  // Live reload will send EntryFinal more than once
  if (env === 'local' && (gcinstant as any).didCallSendEntryFinalAnalytics) {
    return Promise.resolve();
  }

  const entryData =
    gcinstant.entryData ?? ({} as AnalyticsProperties.EntryData);
  // EntryFinal event properties
  const entryFinalEventProps: { [key: string]: any } = {
    $subFeature: entryData.$subFeature,

    // @todo: remove (POST SEASON 2 MIGRATION)
    // sourceSelectionCount: entryData.selectionCount,
    // sourceRealtimeEnergy: entryDataPayload?.sourceRealtimeEnergy,
    // sourceRealtimeEarningsPerHour:
    //   entryDataPayload?.sourceRealtimeEarningsPerHour,
    // sourceRealtimeEarningsPerSecond:
    //   entryDataPayload?.sourceRealtimeEarningsPerSecond,
    // sourceRealtimeScore: entryDataPayload?.sourceRealtimeScore,

    sourceRealtimeBalance: entryDataPayload?.sourceRealtimeBalance,

    creativeVersion: entryDataPayload?.creativeVersion,
  };

  // First session user properties
  const firstEntryUserProps: FirstEntryUserProperties = {
    $firstEntrySourceRealtimeIsPurchaser: false,
    $firstEntrySourceRealtimeLTV: 0,
  };

  // const earningsPerHour = getPowerUpBonusPerHour(state, now);

  // Last session user properties
  const lastEntryUserProps: LastEntryUserProperties = {
    $lastEntryIsPurchaser: false,
    $lastEntryLTV: 0,
    $lastEntrySourceRealtimeIsPurchaser: false,
    $lastEntrySourceRealtimeLTV: 0,

    '#lastEntryBalance': getBalance(state, now),
    // @todo: remove (POST SEASON 2 MIGRATION)
    // '#lastEntryScore': state.score,
    // '#lastEntryLeague': getLeague(state),
    // '#lastEntryEnergy': getEnergy(state, now),
    // '#lastEntryEarningsPerHour': Math.round(earningsPerHour),
    // '#lastEntryEarningsPerSecond': Math.round(earningsPerHour / 3600),
  };

  // Send off all the props to GCInstant
  return gcinstant.sendEntryFinalAnalytics(
    entryFinalEventProps,
    firstEntryUserProps,
    lastEntryUserProps,
  );
}
